import RouteView from "../../navigation/RouteView";
import { settingsRoute } from "./navigation";
import SettingsPage from "./SettingsPage";

export default function SettingsNavigator() {
    return <RouteView route={settingsRoute} component={SettingsPage} />;
}
